import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import CNCalendar from '../cncalendar/CNCalendar';
import AppointmentOverview from './AppointmentOverview';
import CNWorkingPlans from '../cncalendar/CNWorkingPlans';
import CNBreaksPlans from '../cncalendar/CNBreaksPlans';
import FutureAppointments from './FutureAppointments';

const CareNavigatorAppointments = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const handleTabSelect = (index) => {
        setSelectedIndex(index);
        navigate(`${location.pathname}?tab=${index}`, { replace: true });
    };
    return (
        <section className='ContentCareNavigator'>
            <div className="row align-items-center pb-3 sticky-top-bar">
                <div className="col-md">
                    <h1 className="main-title">CareNavigator Appointments</h1>
                </div>
                <div className="col-md text-end">

                </div>
            </div>

            <div className='reports-programs mb-3'>
                <div className="row align-items-center">
                    <div className="col-md-auto">
                        <img src="https://storage.googleapis.com/ksabupatest/2024/09/24/f1rhk/yh4of8cegs.png" alt="Invited Members icon" style={{ height: "140px" }} className="img-fluid mb-0" />
                    </div>
                    <div className="col-md">
                        <p className="mb-3">Overview of all CareNavigator appointments, including status and key metrics. Access individual CareNavigator calendars to track availability and manage schedules effectively.
                        </p>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row align-items-center pb-3">
                    <div className='comntent-CareNavigator mb-3'>
                        <div className="row">
                            <div className="col-md-12">
                                <Tabs selectedIndex={selectedIndex} onSelect={index => handleTabSelect(index)}>
                                    <TabList>
                                        <Tab>Appointment Overview</Tab>
                                        <Tab>Future Appointments</Tab>
                                        <Tab>CareNavigator Calendar</Tab>
                                        <Tab>CareNavigator Working Plans</Tab>
                                        <Tab>CareNavigator Breaks Plans</Tab>
                                    </TabList>

                                    <TabPanel style={{ padding: "10px 0px" }}>
                                        <div className="table-responsive CareNavigatorListTable">
                                            <AppointmentOverview />
                                        </div>
                                    </TabPanel>
                                    <TabPanel style={{ padding: "10px 0px" }}>
                                        <div className="table-responsive CareNavigatorListTable">
                                            <FutureAppointments />
                                        </div>
                                    </TabPanel>
                                    <TabPanel style={{ padding: "0px 0px" }}>
                                        <div className="table-responsive CapacityAssignmentTable">
                                            <CNCalendar />
                                        </div>
                                    </TabPanel>
                                    <TabPanel style={{ padding: "10px 0px" }}>
                                        <div className="table-responsive CapacityAssignmentTable">
                                            <CNWorkingPlans />
                                        </div>
                                    </TabPanel>
                                    <TabPanel style={{ padding: "10px 0px" }}>
                                        <div className="table-responsive CapacityAssignmentTable table-responsive-1">
                                            <CNBreaksPlans />
                                        </div>
                                    </TabPanel>
                                </Tabs>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CareNavigatorAppointments